import type ExcelJS from "exceljs";

import { mimetype } from "@/enums/mimetype";
import downloadFile from "@/utils/downloadFile";

export default async function downloadWorkbook(workbook: ExcelJS.Workbook, fileName: string) {
    const content = await workbook.xlsx.writeBuffer();
    const blob = new Blob([content], { type: mimetype.XSLX });
    const url = URL.createObjectURL(blob);

    try {
        downloadFile(url, fileName);
    } finally {
        URL.revokeObjectURL(url);
    }
}
